<!-- Copyright: Seán I. O'Donoghue -->
<!-- On the test sites (staging, dev) only: a banner fixed to the bottom of the window, styled like
     the top one (CallToAction/Banner.vue) in our attention orange, saying it's a test site. The
     whole banner links to vizbi.org in the same tab (data-same-tab: the externalLinks plugin
     leaves it alone; CLAUDE.md, Navigation). The text is as large as fits on one line, up to the
     top banner's size (useMaxFontSize). -->

<template>
  <template v-if="isTestSite">
    <a id="testSite" :href="MAIN_SITE" data-same-tab @click.prevent="goToMainSite">
      <div class="fit">
        <span ref="textRef">This is a test site. <u>Click here</u> to go to vizbi.org.</span>
      </div>
    </a>
    <div class="spacer" aria-hidden="true" />
  </template>
</template>

<script setup>
import {ref} from "vue";
import {useMaxFontSize} from "@/composables/useMaxFontSize";
import {isTestSite} from "@/composables/isTestSite";

const MAIN_SITE = "https://vizbi.org";
const TOP_BANNER_FONT_SIZE = 28; // px: the top banner's widest (1.73rem)

const textRef = ref(null);
useMaxFontSize(textRef, {maxFontSize: TOP_BANNER_FONT_SIZE});

function goToMainSite() {
  window.location.href = MAIN_SITE; // same tab
}
</script>

<style scoped>
/* the top banner's layout (Banner.vue): full-width colour, text in the page column */
#testSite {
  --attention-orange: var(--orange-on-light); /* ButtonBespoke's orange */
  --main-padding: 1rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50; /* as the top banner: above page content, below modal overlays */
  display: flex;
  align-items: center;
  height: 3rem;
  padding: 0 max(var(--main-padding), calc(50% - 28rem + var(--main-padding)));
  background-color: var(--attention-orange);
  color: white;
  text-decoration: none;
  line-height: 1.05;
  box-sizing: border-box;
}
.narrow #testSite {
  --main-padding: 0.8rem;
}
.fit {
  width: 100%;
  text-align: center;
}
/* a block, so useMaxFontSize can measure the text against the column (an inline span can't be) */
.fit span {
  display: block;
}
/* keeps the page's last lines clear of the banner */
.spacer {
  height: 3rem;
}
</style>
